import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";

import "animate.css/animate.css";

const FinalModal = ({
  classes,
  nextQuestion,
  handleClose,
  answeredCorrectly,
  question,
  isOpen
}) => {
  return (
    <Modal open={isOpen}
    className="animate__animated animate__fadeInRight"
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          <Typography className={classes.stepNumber}>IN THE REAL WORLD</Typography>
          {/* <Grid container justify="center" className={classes.mainLine}>Now we have only people that in the labor force, you can decide which "Friends" are employed or unemployed.</Grid> */}
          <Typography className={classes.evalDesc} dangerouslySetInnerHTML={{ __html: "By the way, our friends' employment stats aren't very representative of the real world. Since 2000, the U.S. <b>Labor Force Participation Rate</b> has averaged around <b>64%</b>, and the <b>Unemployment Rate</b> has averaged around <b>6%</b>." }}>
          </Typography>
          <Grid container justify="center" style={{ padding: 24 }}>
            <Button className={classes.submitButton} onClick={handleClose}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(FinalModal);
